import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.site-preferences')
  .factory('$globals', GlobalsObjectFactory);

/* @ngInject */
function GlobalsObjectFactory($bringozFactory: $bringozFactory,
                              GlobalsAPI: BringozApi) {
  function $globals(id: string) {
    return $bringozFactory(id, GlobalsAPI);
  }

  return $globals;
}
